import type { PropsWithClassProps } from '@vgn-medien-holding/vgn-fe-components';
import type { FC } from 'react';

export const IconSoundOff: FC<PropsWithClassProps> = ({ classProps }) => {
  return (
    <svg
      viewBox="209.539 91.846 78.541 117.81"
      width="17"
      height="18"
      xmlns="http://www.w3.org/2000/svg"
      className={classProps?.root}
    >
      <path
        d="M 275.51 94.008 L 248.214 121.298 L 216.902 121.298 C 212.834 121.298 209.539 124.593 209.539 128.661 L 209.539 172.84 C 209.539 176.905 212.834 180.204 216.902 180.204 L 248.214 180.204 L 275.51 207.493 C 280.121 212.104 288.08 208.865 288.08 202.287 L 288.08 99.214 C 288.08 92.63 280.115 89.403 275.51 94.008 Z"
        fill="currentColor"
      />
    </svg>
  );
};
